import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getClientToken, setClientToken } from "../api/http";
import { getClientProfile, logoutClient } from "../api/auth";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!getClientToken()) {
      setClient(null);
      setLoading(false);
      return;
    }
    try {
      const me = await getClientProfile();
      setClient(me);
    } catch (_) {
      setClientToken("");
      setClient(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const logout = useCallback(async () => {
    await logoutClient();
    setClient(null);
  }, []);

  const value = useMemo(
    () => ({
      client,
      isAuthenticated: !!client,
      loading,
      reload,
      logout,
      setClient,
    }),
    [client, loading, reload, logout]
  );

  return <ClientAuthContext.Provider value={value}>{children}</ClientAuthContext.Provider>;
}

export function useClientAuth() {
  const ctx = useContext(ClientAuthContext);
  if (!ctx) throw new Error("useClientAuth must be used within ClientAuthProvider");
  return ctx;
}
